import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class LocalMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.local.localMapperError"));

        Object.setPrototypeOf(this, LocalMapperError.prototype);
    }
}